import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import floating_vue_EIcJ7xiw0h from "/vercel/path0/.nuxt/floating-vue.mjs";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import server_init_EYS4T8Nor2 from "/vercel/path0/src/plugins/server-init.js";
import apexcharts_client_yxP016Q5gB from "/vercel/path0/src/plugins/apexcharts.client.js";
import filters_5KRCPJ3A0b from "/vercel/path0/src/plugins/filters.js";
import link_KptppjLr2w from "/vercel/path0/src/plugins/link.js";
import luxon_zWvsx9cVza from "/vercel/path0/src/plugins/luxon.js";
import ui_kZUsFzhBvm from "/vercel/path0/src/plugins/ui.js";
import sentry_h0fMjCG9AB from "/vercel/path0/src/plugins/sentry.ts";
import vercel_analytics_client_Po8wDakAq8 from "/vercel/path0/src/plugins/vercel-analytics.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  floating_vue_EIcJ7xiw0h,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  server_init_EYS4T8Nor2,
  apexcharts_client_yxP016Q5gB,
  filters_5KRCPJ3A0b,
  link_KptppjLr2w,
  luxon_zWvsx9cVza,
  ui_kZUsFzhBvm,
  sentry_h0fMjCG9AB,
  vercel_analytics_client_Po8wDakAq8
]